<template>

  <div class="bb-progress-top-wrapper row justify-content-between align-items-center">
    <div class="col-auto text-left" style="min-width: 8rem;"><prev-step></prev-step></div>
    <div class="col">
      <v-stepper
        alt-labels
        :value="step"
      >
        <v-stepper-header>
          <template v-for="(s, index) in customstates.states">
            <v-divider v-if="index > 0"></v-divider>
            <v-stepper-step-link
              :step-name="s.name"
              :class="['step-' + index, 'step-' + s.name.replace(/\./g, '-')]"
              :step="index + 1"
              editable
              :value="currentRouteName"
              v-show="!s.hidden"
              :complete="customstates.completed[s.name]"
              :rules="[rules.stepIsValid]"
              :href="$router.resolve({ name: s.name }).href"
              complete-icon="fas fa-pencil"
            >{{ s.textName }}</v-stepper-step-link>
          </template>
        </v-stepper-header>
      </v-stepper>
    </div>
    <div class="col-auto d-flex align-items-center justify-content-end text-right">
      <next-step :id="`${prefix}next-step`"></next-step>
      <add-to-cart v-if="customband.template === 'fixed' && isLastStep" stage="stage" display-alert="displayAlert" display-warning="displayWarning"></add-to-cart>
      <!--<tyveksummary v-if="customband.template === 'free' && isLastStep" class="force-right" stage="stage" display-alert="displayAlert" @click="submit()"></tyveksummary>-->
    </div>
  </div>

</template>

<script>
  import { mapState } from 'vuex'
  import _get from 'lodash/get'
  import routes from '../mixins/routes'

  export default {
    props: ['prefix', 'states'],

    mixins: [routes],

    data () {
      return {
        rules: {
          stepIsValid: (stepComponent) => {
            let stepIsCompleted = _get(this.customstates.completed, stepComponent.stepName)
            return stepIsCompleted !== false
          }
        }
      }
    },

    computed: {
      step () {
        return this.currentRouteIndex + 1
      },
      currentRouteIndex () {
        let currentName = this.$route.name
        let currentIndex = this.customstates.states.findIndex(state => state.name === currentName)
        return currentIndex
      },
      currentRouteName () {
        return this.$route.name
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'customstates'
      ])
    },

    methods: {

    },

    created () {
      // console.log('NavTop created!')
      // console.log('this.states', this.states)
      // console.log('this.customstates', this.customstates)
      // console.log('this.customstates.states', this.customstates.states)
    }
  }
</script>
